import cn from "clsx";
import { Col, PrimaryButton, Row } from "@crehana/ui";
import useNewDashboardTranslations from "./hooks/useNewDashboardTranslations";
import useNewDashboardContext from "./context/useNewDashboardContext";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DashboardEmptyView = function DashboardEmptyView(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    isDarkProp = _ref.isDark,
    error = _ref.error,
    onRetry = _ref.onRetry,
    defaultConnectionError = _ref.defaultConnectionError,
    supportsDarkMode = _ref.supportsDarkMode,
    dataTestId = _ref['data-testid'];
  var _useNewDashboardTrans = useNewDashboardTranslations(),
    t = _useNewDashboardTrans.t;
  var _useNewDashboardConte = useNewDashboardContext(),
    isDark = _useNewDashboardConte.isDark;
  var dark = supportsDarkMode && (isDarkProp || isDark);
  var onReload = function onReload() {
    window.location.reload();
  };
  return /*#__PURE__*/_jsx("div", {
    className: cn('w-full', dark ? 'bg-base-lighter-24' : 'bg-base-lighter-16', className),
    "data-testid": dataTestId,
    children: /*#__PURE__*/_jsx(Row, {
      nowrap: true,
      className: "flex justify-center",
      children: /*#__PURE__*/_jsx(Col, {
        xs: 12,
        sm: 10,
        lg: 8,
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col items-center px-16 py-16 text-center sm:py-32 sm:px-0",
          children: [/*#__PURE__*/_jsx("h4", {
            className: cn("font-subtitle2", dark ? 'text-white' : 'text-base-main'),
            children: error || (defaultConnectionError ? t('INTERNET_CONNECTION_ERROR') : t('GENERAL_ERROR'))
          }), (onRetry || defaultConnectionError) && /*#__PURE__*/_jsx(PrimaryButton, {
            className: "w-full mt-16 sm:w-auto",
            label: defaultConnectionError ? t('RELOAD_PAGE') : t('TRY_AGAIN'),
            onClick: onRetry || onReload,
            isDark: dark
          })]
        })
      })
    })
  });
};
export default DashboardEmptyView;